<div class="flex-row-container m-3 p-3 mat-elevation-z6" *ngIf="appointment">
  <!-- <div style="word-wrap: break-word;">{{diagnostic}}</div> -->

  <h1 *ngIf='eventID === 0'>{{ 'FIND-TIME.CREATE-APPOINTMENT' | translate }}</h1>
  <h1 *ngIf='eventID > 0'>{{ 'FIND-TIME.APPOINTMENT-DETAILS' | translate}}</h1>

  <form class="flex-row-container" [formGroup]="form" (ngSubmit)="onSubmit(form.value)">

    <div fxLayout="column" fxLayoutAlign="space-evenly">
      <span class="w-100" fxLayoutAlign="space-between center">
        <span><b>{{ 'COMMON.PATIENT-NAME' | translate }}:</b> {{ patientName }}</span>
        <span>{{'COMMON.BALANCE'  | translate}}: <span
            [class.negative]="balance < 0">{{balance | number:'1.2-2' }}</span></span>
      </span>
      <span><b>{{ 'COMMON.AGE' | translate }}:</b> {{ age }} </span>
      <span><b>{{ 'COMMON.GENDER' | translate }}:</b> {{ gender }} </span>
      <span><b>{{ 'COMMON.VISIT-REASON' | translate }}:</b>
        <div>
          <div *ngFor="let currentTreatment of treatments">
            <div   fxLayout="column"  fxLayoutAlign="start">
              <span class="m-1 w-100">{{ getTreatmentVisitReason(currentTreatment) }}</span>
               <span class="mb-2">
                <span class="m-1">
                  <button mat-stroked-button 
                  color="primary" 
                  stroke="primary"
                  (click)="enterTreatmentComment($event, currentTreatment)" 
                  [disabled]="currentTreatment.Name === 'Appt.auto'">{{'COMMON.TREATMENT-DESCRIPTION' | translate}}</button>
                </span>
                
                  <span class="m-1"><mat-checkbox color="primary" class="m-2" [checked]="isTreatmentDone(currentTreatment)"
                  (change)="setTreatmentDone($event, currentTreatment)" [disabled]="!canChangeTreatmentStatusToDone(currentTreatment)">{{'COMMON.TREATMENT-DONE' | translate}}</mat-checkbox></span> 
               </span>
               <span *ngIf="currentTreatment.Name === 'Appt.auto'" style="color: red;">{{'MSG.EDIT-TREATMENT-DESCRIPTION-NOT-DUE-CONVERSION' | translate}}</span>
            </div>
          </div>


          <!-- <div *ngFor="let reason of visitReason;let i = index" [attr.data-index]="i">
            {{ reason }} <br />
            <span class="pt-2 pb-2">
              <button mat-stroked-button color="primary" stroke="primary"
                (click)="enterTreatmentComment($event, i)">{{'COMMON.TREATMENT-DESCRIPTION' | translate}}</button>
              <mat-checkbox color="primary" class="m-2" [checked]="isTreatmentDone(treatments[i])"
                (change)="setTreatmentDone($event, i)">{{'COMMON.TREATMENT-DONE' | translate}}</mat-checkbox>
            </span>
          </div> -->
        </div>

      </span>

      <span><b>{{ 'COMMON.MOBILE-PHONE' | translate }}:</b> {{ phone }} </span>
      <span><b>{{ 'COMMON.THERAPIST' | translate }}:</b> {{ schedulerName }} | {{branchName}}</span>
      <span><b>{{ 'COMMON.DATE-AND-TIME' | translate }}:</b>&nbsp;
        <span><b></b>{{ start | amDateFormat: 'ddd' }}</span>
        <span style="margin:0 5px;">|</span>
        <span>{{ start | amDateFormat: 'L' }}</span>
        <span style="margin:0 5px;">|</span>
        <span>{{ start | amDateFormat: 'LT'}}-{{ end | amDateFormat: 'LT'}}</span>
      </span>
       <span *ngIf="isReasonRequired || (appointment.Treatments?.length >0 ?? true)"><b> {{ 'COMMON.DURATION' | translate }}: </b> {{ form.controls.duration.value }} {{ 'TIME.MINS' | translate}}</span>
      <span>

       
    </span>
    </div>    
    <div>
      

      
      <app-treatment-selection *ngIf="!isReasonRequired"
      [treatments]="treatments"
      [priceListCodes]="priceListCodes"
      [schedulers]="schedulers"
      [branches]="branches"
      [isReasonRequired]="isReasonRequired"
      [hasTreatmentsTodo]="hasTreatmentsTodo"
      [patientID]="patientID"
      [scheduler]="schedulerID"
      [branchID]="appointment.BranchID"
      [practiceID]="practiceID"
      (onSelectVisitReasonClick)="onSelectVisitReason($event)"
      (onClearPriceListCodeClick)="onClearPriceListCode($event)"
      (onClearTreatmentClick)="onClearTreatment($event)"
      (onClearVisitReasonClick)="onClearVisitReason($event)"></app-treatment-selection>
    </div>

    <mat-form-field *ngIf="!isReasonRequired">
      <mat-label>{{ 'COMMON.DURATION' | translate }}  {{ 'TIME.MINS' | translate}}</mat-label>
      <input type="number" [attr.min]="minDuration" [attr.max]="maxDuration" step="5" matInput
        placeholder="{{ 'COMMON.DURATION' | translate }}" formControlName="duration"
         [disabled]="!canChangeDuration"
         (blur)="onDurationChanged()">
      <mat-error *ngIf="form.controls.duration.errors?.required">{{ 'ERROR.DURATION-REQUIRED' | translate }}
      </mat-error>
      <mat-error *ngIf="form.controls.duration.hasError('min')">{{ 'ERROR.DURATION-MIN-INVALID' |translate: {
        'minutes': 5 } }}</mat-error>
      <mat-error *ngIf="form.controls.duration.hasError('max')">{{ 'ERROR.DURATION-MAX-INVALID' |translate: {
        'minutes': 120 } }}</mat-error>
    </mat-form-field>
  

    <mat-form-field>
      <mat-label>{{ 'COMMON.PRICE' | translate }}</mat-label>
      <input matInput type="number" placeholder="0.00" formControlName="price" (blur)="toDecimal($event.target.value)">
      <!-- <mat-error *ngIf="form.controls.password.errors?.required">{{ 'LOGIN.PASSWORD-REQUIRED' | translate }}</mat-error>-->
      <mat-error *ngIf="form.controls.price.hasError('min')">{{ 'ERROR.MINPRICE' | translate: { 'min': '0'} }}
      </mat-error>
      <mat-error *ngIf="form.controls.price.hasError('max')">{{ 'ERROR.MAXPRICE' | translate: { 'max': '99,999'} }}
      </mat-error>
    </mat-form-field>

    <mat-form-field>
      <mat-label *ngIf="isRoomRequired">{{ 'SCHEDULER.SELECT-ROOM' | translate }} <span class="accent-color">*</span></mat-label>
      <mat-select placeholder="{{ 'COMMON.ROOM' | translate }}" formControlName="room">
        <mat-option>{{ 'COMMON.NONE' | translate }}</mat-option>
        <mat-option *ngFor="let currentRoom of rooms" [value]="currentRoom.ID">
          {{currentRoom.Name}} </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field>
      <mat-label>{{ 'COMMON.NOTE' | translate }}</mat-label>
      <textarea matInput cdkTextareaAutosize placeholder="{{ 'COMMON.NOTE' | translate }}" formControlName="note"
        maxlength="256"></textarea>
      <mat-error *ngIf="form.controls.note.errors?.maxlength">{{ 'ERROR.MAXLENGTH' | translate: { length: 256} }}
      </mat-error>
    </mat-form-field>

    <mat-form-field>
      <mat-select placeholder="{{ 'COMMON.LABEL' | translate }}" formControlName="selectedColor">
        <mat-select-trigger>
          <span *ngIf="form.get('selectedColor').value" class="round"
            [style.background-color]="form.get('selectedColor').value.Background"></span>
          {{ form.get('selectedColor').value ? form.get('selectedColor').value.Name : 'bb'}}
        </mat-select-trigger>
        <mat-option>{{ 'COMMON.NONE' | translate }}</mat-option>
        <mat-option *ngFor="let selectedColor of labels" [value]="selectedColor">
          <span class="round" [style.background-color]="selectedColor.Background"></span>&nbsp;{{selectedColor.Name}}
        </mat-option>
      </mat-select>
    </mat-form-field>


    <div fxLayout="row" fxLayoutGap="20px">
      <mat-checkbox formControlName="sms">SMS</mat-checkbox>
      <mat-checkbox formControlName="email">Email</mat-checkbox>
      <mat-checkbox formControlName="whatsapp">WhatsApp</mat-checkbox>
    </div>

    <div fxLayout="row" fxLayoutAlign="space-around center">
      <div class="markContainer">
       
        <select id="confirmed" 
        class="d-checkbox" 
        [class.ic-ok]="f.confirmed.value === confirmeAppointmentType.Confirmed"
        [class.confirmed-online]="f.confirmed.value === confirmeAppointmentType.ConfirmedOnlineByPatient"
        [class.decline]="f.confirmed.value === confirmeAppointmentType.Decline"
        [selected]="confirmed" 
        formControlName="confirmed">
          <option value="0">0</option>
          <option value="1">1</option>
          <option value="2">2</option>
          <option value="3">3</option>
        </select>

        <label for="confirmed" class="d-checkbox-label" (click)="onClick_markApptAs($event)">
          <span class="ic-large ic-ok"></span>
          <span class="ic-small ic-ok"></span>
          <span class="alert-text">{{ 'COMMON.CONFIRMED' | translate}}</span>
        </label>
      </div>
      <!-- <div class="markContainer">
        <input id="confirmed" class="d-checkbox" type="checkbox" [checked]="confirmed" formControlName="confirmed">
        <label for="confirmed" class="d-checkbox-label" (click)="onClick_markApptAs($event)">
          <span class="ic-large ic-ok"></span>
          <span class="ic-small ic-ok"></span>
          <span class="alert-text">{{ 'COMMON.CONFIRMED' | translate}}</span>
        </label>
      </div> -->
      <div class="markContainer">
        <input id="arrived" class="d-checkbox" type="checkbox" [checked]="arrived" formControlName="arrived">
        <label for="arrived" class="d-checkbox-label" (click)="onClick_markApptAs($event)">
          <span class="ic-large ic-arrived"></span>
          <span class="ic-small ic-arrived"></span>
          <span class="alert-text">{{ 'COMMON.ARRIVED' | translate}}</span>
        </label>
      </div>
      <div class="markContainer">
        <input id="noShow" class="d-checkbox" type="checkbox" [checked]="noShow" formControlName="noShow">
        <label for="noShow" class="d-checkbox-label" (click)="onClick_markApptAs($event)">
          <span class="ic-large ic-d-show"></span>
          <span class="ic-small ic-d-show"></span>
          <span class="alert-text">{{ 'COMMON.NO-SHOW' | translate}}</span>
        </label>
      </div>
      <div class="markContainer">
        <input id="paid" class="d-checkbox" type="checkbox" [checked]="paid" formControlName="paid">
        <label for="paid" class="d-checkbox-label" (click)="onClick_markApptAs($event)">
          <span class="ic-large ic-paid"></span>
          <span class="ic-small ic-paid"></span>
          <span class="alert-text">{{ 'COMMON.PAID' | translate}}</span>
        </label>
      </div>
    </div>
   

    <div fxLayout="row" fxLayoutGap="15px" fxLayoutAlign="center">
      <button mat-raised-button class="mat-elevation-z6  mt-3" (click)="onCancel($event)">{{
        'COMMON.CANCEL' | translate }}</button>

      <button mat-raised-button color="accent" class="mat-elevation-z6  mt-3" type="submit" [disabled]="!form.valid">{{
        'COMMON.SAVE' | translate }}</button>
    </div>


    <mat-error *ngIf="error" class="alert alert-danger">{{error}}</mat-error>
  </form>
</div>